import PassportCreateRequirements from "./PassportCreateRequirements";

export default PassportCreateRequirements;
